var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseFillBlackIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM18.8457 18.9863L16.9121 18.9775L14 15.5059L11.0908 18.9746L9.1543 18.9834C9.02539 18.9834 8.91992 18.8809 8.91992 18.749C8.91992 18.6934 8.94043 18.6406 8.97559 18.5967L12.7871 14.0557L8.97559 9.51758C8.94018 9.47464 8.92054 9.42088 8.91992 9.36523C8.91992 9.23633 9.02539 9.13086 9.1543 9.13086L11.0908 9.13965L14 12.6113L16.9092 9.14258L18.8428 9.13379C18.9717 9.13379 19.0771 9.23633 19.0771 9.36816C19.0771 9.42383 19.0566 9.47656 19.0215 9.52051L15.2158 14.0586L19.0244 18.5996C19.0596 18.6436 19.0801 18.6963 19.0801 18.752C19.0801 18.8809 18.9746 18.9863 18.8457 18.9863Z",
    fill: "#010101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFillBlackIc);
export default __webpack_public_path__ + "static/media/close_fill_black_ic.23d48684a39fbf1cfdaac85957a787ed.svg";
export { ForwardRef as ReactComponent };